import { get, post, put } from '../../lib/api/client';

/**
 * Admin second factor (BE admin-mfa.go). Every call carries `X-Device-Id`
 * (lib/api/client); the BE refuses /admin/* with MFA_REQUIRED until the profile
 * has a phone and this device has passed an SMS code.
 */
export interface MfaStatus {
  phoneOnFile: boolean;
  /** Last four digits of the phone on file, for "…0100"; '' when none. */
  phoneLast4: string;
  deviceVerified: boolean;
}

export const getMfaStatus = (signal?: AbortSignal) => get<MfaStatus>('/admin/mfa/status', undefined, signal);

/** Texts a code to the phone on file for this device. */
export const sendMfaCode = () => post<{ sent: boolean; phoneLast4: string }>('/admin/mfa/code');

/** Marks this device verified. */
export const verifyMfaCode = (code: string) => post<{ deviceVerified: boolean }>('/admin/mfa/verify', { code });

/** Sets the signed-in admin's password (needs a verified device). */
export const setAccountPassword = (password: string) =>
  put<{ updated: boolean }>('/admin/account/password', { password });

/** The BE's floor; the form checks it first. */
export const MIN_PASSWORD_LENGTH = 8;
